import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Stack, Box, CircularProgress,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

/**
 * ConfirmDialog — zëvendëson window.confirm().
 *
 * window.confirm bllokon fillin e UI-së, del me kokën "localhost:3000 says",
 * nuk e ndjek temën e aplikacionit dhe s'ka mënyrë të tregojë ÇFARË po preket.
 * Ky dialog e mban stilin e shtëpisë (shih "Proceso pagat" te AddList) dhe lejon
 * një bllok `details` që e bën të qartë objektin e veprimit para se të konfirmohet.
 *
 * `busy` e mban dialogun hapur dhe të bllokuar sa zgjat veprimi, që një klikim i
 * dyfishtë të mos e dërgojë kërkesën dy herë.
 */
export default function ConfirmDialog({
  open,
  title,
  message,
  details       = null,
  confirmLabel  = 'Konfirmo',
  cancelLabel   = 'Anulo',
  busyLabel     = 'Duke procesuar…',
  color         = 'error',
  icon          = <WarningAmberIcon />,
  busy          = false,
  onConfirm,
  onClose,
}) {
  return (
    <Dialog
      open={open}
      onClose={busy ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2.5 } }}
    >
      <DialogTitle sx={{ fontWeight: 800, fontSize: '1rem', pb: 1.5 }}>
        <Stack direction="row" alignItems="center" spacing={1.25}>
          <Box sx={{
            width: 34, height: 34, borderRadius: '50%', flexShrink: 0,
            display: 'grid', placeItems: 'center',
            bgcolor: `${color}.light`, color: `${color}.dark`,
            '& svg': { fontSize: 20 },
          }}>
            {icon}
          </Box>
          <span>{title}</span>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        {message && (
          <Typography sx={{ fontSize: '0.88rem', color: 'text.primary', mb: details ? 1.5 : 0 }}>
            {message}
          </Typography>
        )}
        {details && (
          <Box sx={{
            p: 1.25, borderRadius: 1.5,
            bgcolor: 'action.hover', border: '1px solid', borderColor: 'divider',
          }}>
            {details}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 2, py: 1.5 }}>
        <Button onClick={onClose} disabled={busy}
          sx={{ textTransform: 'none', fontWeight: 700 }}>
          {cancelLabel}
        </Button>
        <Button variant="contained" color={color} disableElevation
          onClick={onConfirm} disabled={busy}
          startIcon={busy ? <CircularProgress size={15} color="inherit" /> : null}
          sx={{ textTransform: 'none', fontWeight: 700 }}>
          {busy ? busyLabel : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
